import React, { Component } from 'react'
import Footer from '../../Components/Footer/Footer'
import classes from './BillingPage.module.css'
class BilligPage extends Component{
    render(){
        return(
            <div>
                <div className={classes.container}>
                <div className={classes.card}>
                    <p className={classes.pay}>Pay</p>
                    <div className={classes.amountContainer}>
                    <i className="fa fa-inr"  style={{"font-size":"0.7em","margin-bottom":"0px"}}></i>
                    110/-
                    </div>
                    <p className={classes.remarks}>Get your study material for upcoming exams</p>
                    <button className={classes.btn2}>Buy Now</button>
                </div>
                
                <div className={classes.content}>
                <p className={classes.head}>
                    Details
                </p>
                <hr className={classes.hr}/>
                <ul className={classes.list}>
                    <li className={classes.listItem}>Get content as per your University Syllabus.</li>
                    <li className={classes.listItem}> You will have content till your exams are over.</li>
                </ul>
                </div>
                <div className={classes.promoContainer}>
                    <input className={classes.input} placeholder="Enter promo code"/>
                    <button className={classes.btn}>Apply</button>
                </div>
                </div>
                <Footer/>
            </div>
        )
    }
}
export default BilligPage;